import { configureStore, Tuple } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { createRootReducer } from './root-reducer';
import { rootSaga } from './root-saga';
export const history = createBrowserHistory();
const reducer = createRootReducer();
// const routerMiddleWare = routerMiddleware(history);
const sagaMiddleWare = createSagaMiddleware();
/** LogRocket Redux middleware was removed from the critical path; LogRocket loads async from `vendor/log-rocket`. */ const noopTrailingMiddleware = ()=>(next)=>(action)=>next(action);
export const store = configureStore({
    reducer,
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    middleware: ()=>new Tuple(sagaMiddleWare, noopTrailingMiddleware)
});
if (window.Cypress) {
    window.store = store;
}
export const sagaTaskDescriptor = sagaMiddleWare.run(rootSaga);
